// src/modules/units/tyres/views/retread-batch/retreadbatchconfirm.view.js
//
// Pure shell for the operation confirm screens (dispatch, cancel). Data in, HTML
// out; no fetch, no DOM. Reuses the shared tm-form primitives so it reads like the
// create form. The orchestrators own the outcome (cap warnings, retry, back) and
// drive the primary button via its data-confirm-ok hook.

import { esc } from '../../shared/tyre-format.js';

/**
 * @param {object} p
 * @param {string}  p.title
 * @param {string}  [p.sub]
 * @param {string}  [p.warn]        a highlighted caution line (e.g. "tyres return to stock")
 * @param {string}  [p.fieldsHTML]  optional form rows (dispatch supplies these)
 * @param {string}  [p.confirmLabel]
 * @param {boolean} [p.danger]      style the primary button as destructive
 */
export function confirmHTML({ title = '', sub = '', warn = '', fieldsHTML = '', confirmLabel = 'Confirm', danger = false, cancelLabel = 'Cancel' } = {}) {
  return `
    <div class="tm-form tm-rb-confirm">
      <div class="tm-form-head">
        <div>
          <h2 class="tm-form-title">${esc(title)}</h2>
          ${sub ? `<p class="tm-form-sub">${esc(sub)}</p>` : ''}
        </div>
      </div>

      ${warn ? `<div class="tm-rb-confirm-warn">${esc(warn)}</div>` : ''}
      <div class="tm-form-msg" data-confirm-msg hidden></div>
      ${fieldsHTML ? `<div class="tm-form-grid">${fieldsHTML}</div>` : ''}

      <div class="tm-form-actions">
        <button type="button" class="tm-btn-secondary" data-confirm-cancel>${esc(cancelLabel)}</button>
        <button type="button" class="tm-btn-${danger ? 'danger' : 'primary'}" data-confirm-ok>${esc(confirmLabel)}</button>
      </div>
    </div>`;
}

/** Dispatch's optional fields — a date (defaults to today) and a delivery-note ref. */
export function dispatchFieldsHTML({ dispatchedAt = '', dispatchReference = '' } = {}) {
  return `
    <div class="tm-form-row">
      <label class="tm-form-label" for="tm-rb-dispatched">Dispatch date</label>
      <input id="tm-rb-dispatched" type="date" class="tm-input" data-confirm-field="dispatchedAt" value="${esc(dispatchedAt)}" />
      <p class="tm-field-help">Optional — defaults to today.</p>
    </div>
    <div class="tm-form-row tm-form-row-wide">
      <label class="tm-form-label" for="tm-rb-dispatch-ref">Delivery note reference</label>
      <input id="tm-rb-dispatch-ref" type="text" class="tm-input" data-confirm-field="dispatchReference" value="${esc(dispatchReference)}"
             placeholder="Optional — the supplier's delivery note or your dispatch reference." />
    </div>`;
}
